import Link from 'next/link';
import BreadCrumbsArrow from './svg/BreadCrumbsArrow';
import { twMerge } from 'tailwind-merge';

interface Props {
  className?: string;
  items: {
    title: string;
    href?: string;
    className?: string;
  }[];
}

export default function BreadCrumbs({className, items}: Props) {

  return (
    <div className={twMerge('flex items-center flex-wrap gap-[12px]', className)}>
      {items.map((x,i) => {
        const isLast = i === items.length - 1;
        return (
          <>
          {x.href ? <Link className={twMerge('text-primary sm font-medium flex-shrink-0 last:flex-shrink', x.className)} href={x.href}>{x.title}</Link> : <div className={twMerge('text-gray-700 sm font-medium flex-shrink-0 last:flex-shrink', x.className)}>{x.title}</div>}
          {isLast ? null : <BreadCrumbsArrow className='flex-shrink-0'/>}
          </>
        )
      })}
    </div>
  )

}